// extracted by mini-css-extract-plugin
export default {"container":"ColladaOverlayCine-styles-module--container--pEUIo"};